<div class="text-box-container">
  <div class="question-header">
    <h6 class="m-0 p-0"
    [style.font-size]="questionnaire?.mainContentTemplate?.questionStyle?.fontSize + 'px'"
    [style.font-family]="questionnaire?.mainContentTemplate?.questionStyle?.fontFamily"
    [style.font-weight]="questionnaire?.mainContentTemplate?.questionStyle?.boldStyle"
    [style.color]="questionnaire?.mainContentTemplate?.questionStyle?.fontColor"
    >
      {{ questionNumber }}. {{ question?.question || 'Untitled Question' | titlecase }}
      @if(question?.required) {
        <span 
        [style.font-size]="'18px'"
        [style.font-family]="questionnaire?.mainContentTemplate?.errorMessageStyle?.fontFamily"
        [style.font-weight]="questionnaire?.mainContentTemplate?.errorMessageStyle?.boldStyle"
        [style.color]="questionnaire?.mainContentTemplate?.errorMessageStyle?.fontColor"
        >*</span>
      }
    </h6>
  </div>

  <div class="question-content-rating">
    <div class="rating-scale">
      <!-- Labels Row -->
      @if(question?.questionSpecificOptions?.labels?.length) {
        <div class="labels-row" 
        [ngClass]="'labels-row-width-' + getScaleArray(toNumber(scaleCount)).length">
          @for(label of question?.questionSpecificOptions?.labels || []; track label) {
            <span class="rating-label"
            [style.font-size]="questionnaire?.mainContentTemplate?.choiceStyle?.fontSize + 'px'"
            [style.font-family]="questionnaire?.mainContentTemplate?.choiceStyle?.fontFamily"
            [style.font-weight]="questionnaire?.mainContentTemplate?.choiceStyle?.boldStyle"
            [style.color]="questionnaire?.mainContentTemplate?.choiceStyle?.fontColor"
            >{{ label.text | titlecase }}</span>
          }
        </div>
      }

      <!-- Buttons Row -->
      <div class="buttons-row">
        @for(i of getScaleArray(toNumber(scaleCount)); track i) {
          <button
          type="button"
          class="rating-icon p-0"
          [class.text-primary]="selectedRating !== null && selectedRating >= i"
          (click)="selectRating(i, $event)"
        >
          <span class="d-flex flex-column align-items-center justify-content-center gap-1">
            @switch (question?.questionSpecificOptions?.scaleType) { 
              @case (ratingScaleSubType.STAR) {
                <i class="bi bi-{{ selectedRating !== null && selectedRating >= i ? 'star-fill' : 'star' }}"></i>
              }
              @case (ratingScaleSubType.HEART) {
                <i class="bi bi-{{ selectedRating !== null && selectedRating >= i ? 'heart-fill' : 'heart' }}"></i>
              }
              @case (ratingScaleSubType.THUMBS_UP) {
                <i class="bi bi-{{ selectedRating !== null && selectedRating >= i ? 'hand-thumbs-up-fill' : 'hand-thumbs-up' }}"></i>
              }
              @case (ratingScaleSubType.THUMBS_DOWN) {
                <i class="bi bi-{{ selectedRating !== null && selectedRating >= i ? 'hand-thumbs-down-fill' : 'hand-thumbs-down' }}"></i>
              }
              @case (ratingScaleSubType.SMILE) {
                <i class="bi bi-{{ selectedRating !== null && selectedRating >= i ? 'emoji-smile-fill' : 'emoji-smile' }}"></i>
              }
              @case (ratingScaleSubType.SAD) {
                <i class="bi bi-{{ selectedRating !== null && selectedRating >= i ? 'emoji-frown-fill' : 'emoji-frown' }}"></i>
              }
              @case (ratingScaleSubType.ANGRY) {
                <i class="bi bi-{{ selectedRating !== null && selectedRating >= i ? 'emoji-angry-fill' : 'emoji-angry' }}"></i>
              }
              @case (ratingScaleSubType.EMOJI) {
                <i class="bi bi-{{ selectedRating !== null && selectedRating >= i ? 'emoji-laughing-fill' : 'emoji-laughing' }}"></i>
              }
              @case (ratingScaleSubType.NUMBER) {
                <span class="fs-6 fw-semibold">{{ i }}</span>
              }
              @default {
                <i class="bi bi-{{ selectedRating !== null && selectedRating >= i ? 'circle-fill' : 'circle' }}"></i>
              }
            }
            
                    
            <!-- <span class="rating-text">{{ i }}</span> -->
          </span>
        </button>
        }
      </div>
    </div>
  </div>
</div>
